import { render, staticRenderFns } from "./member_quanyi.vue?vue&type=template&id=1fd3878c&scoped=true"
import script from "./member_quanyi.vue?vue&type=script&lang=js"
export * from "./member_quanyi.vue?vue&type=script&lang=js"
import style0 from "./member_quanyi.vue?vue&type=style&index=0&id=1fd3878c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3878c",
  null
  
)

export default component.exports